import React from "react";
import { connect } from "react-redux";
import { Menu, Dropdown } from "antd";
import { branchSelectors, changeBranch } from "redux/branches.slice";
import { CheckOutlined, DownOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";

function BranchDropdown(currentBranch, branches, onBranchSelect) {
  return (
    <Menu onClick={onBranchSelect}>
      {branches.map((branch) => (
        <Menu.Item
          key={branch.id}
          className={
            currentBranch.id === branch.id
              ? "ant-dropdown-menu-item-active"
              : ""
          }
        >
          <span className="d-flex justify-content-end align-items-center">
            {currentBranch.id === branch.id ? (
              <CheckOutlined className="text-success" />
            ) : null}

            <span className="font-weight-normal ml-2">{branch.name}</span>
          </span>
        </Menu.Item>
      ))}
    </Menu>
  );
}

function BranchSelector({ role, currentBranch, branches, changeBranch }) {
  const history = useHistory();
  const location = useLocation();

  function onBranchSelect(item) {
    if (location.pathname.toLowerCase().startsWith("/app/groups")) {
      history.push("/app/groups");
    } else if (location.pathname.toLowerCase().startsWith("/app/contracts")) {
      history.push("/app/contracts");
    } else if (location.pathname.toLowerCase().startsWith("/app/garage")) {
      history.push("/app/garage");
    }
    changeBranch(item.key);
  }
  
  if (!currentBranch || role !== "Admin") {
    return null;
  }

  const branchDropdown = BranchDropdown(
    currentBranch,
    branches,
    onBranchSelect
  );

  return (
    <Dropdown
      overlay={branchDropdown}
      placement="bottomRight"
      trigger={["click"]}
    >
      <Menu mode="horizontal">
        <Menu.Item>
          <a href="#/" onClick={(e) => e.preventDefault()}>
            <DownOutlined className="nav-icon mr-0" />
            <span className="font-weight-bold ml-2">{currentBranch.name}</span>
          </a>
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
}

const mapStateToProps = (state) => {
  const { role, branchId } = state.auth;

  return {
    branches: branchSelectors.selectAll(state),
    currentBranch: branchSelectors.selectById(state, branchId),
    role: role,
  };
};

export default connect(mapStateToProps, { changeBranch })(BranchSelector);
